import { action } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, InputDropdownMultiSelectFilter } from 'Mri.Web.Common';
import * as React from 'react';
import { DisplayFiltersStore } from './DisplayFiltersStore';
import { DisplayListViewModel } from './DisplayListViewModel';

export interface IStateOrProvincesFilterProps {
    readonly vm: DisplayListViewModel;
}

@autoinject
@observer
export class StateOrProvincesFilter extends React.Component<IStateOrProvincesFilterProps> {
    public render() {
        const { displayFilter, filterOptions, onFilterDropdownToggle } = this.props.vm;

        return (
            <InputDropdownMultiSelectFilter
                title="State Or Province"
                all={this.displayFiltersStore.all?.stateOrProvinces}
                disabled={this.props.vm.disabledFilters.includes('stateOrProvince')}
                filter={displayFilter.stateOrProvinces}
                options={filterOptions?.stateOrProvinces.filter(s => s != '')}
                style={{
                    minWidth: 400,
                }}
                onChange={this.onChange}
                onToggle={onFilterDropdownToggle}
                openOnMount
            />
        );
    }

    @action
    public componentWillUnmount() {
        this.onChange(undefined);
    }

    @bind
    @action
    private onChange(value: string[] | undefined) {
        const { displayFilter } = this.props.vm;
        displayFilter.stateOrProvinces = value;
    }

    @inject
    private readonly displayFiltersStore!: DisplayFiltersStore;
}
